import { useMemo } from 'react';
import { resolveRichText, verifyCrossLinks } from '@vibesites/runtime';
import {
  EditableToken,
  useContentToken,
  useVibesites,
} from '@vibesites/runtime/react';
import { transformBedroomRangeInResolvedHtml } from '../utils/bedroomFormatting';

interface HeroSubtitleRichTextProps {
  path: string;
  defaultValue?: string;
  className?: string;
}

function stripSingleWrappingParagraph(html: string): string {
  const match = html.match(/^<p>([\s\S]*)<\/p>$/);
  if (!match) return html;
  const inner = match[1];
  if (/<p[\s>]|<div[\s>]|<h[1-6][\s>]/i.test(inner)) return html;
  return inner;
}

export function HeroSubtitleRichText({
  path,
  defaultValue,
  className,
}: HeroSubtitleRichTextProps) {
  const { property, pagePaths } = useVibesites();
  const rawHtml = useContentToken(path, { defaultValue });

  const resolvedHtml = useMemo(() => {
    if (!rawHtml) return '';
    let html = resolveRichText(rawHtml, property as Record<string, unknown>);
    html = transformBedroomRangeInResolvedHtml(html, property);
    html = verifyCrossLinks(html, pagePaths);
    return stripSingleWrappingParagraph(html);
  }, [rawHtml, property, pagePaths]);

  return (
    <EditableToken
      path={path}
      type="richtext"
      as="h1"
      className={className}
      defaultValue={defaultValue}
    >
      <span
        data-vibesite-richtext=""
        dangerouslySetInnerHTML={{ __html: resolvedHtml }}
        style={{ display: 'contents' }}
      />
    </EditableToken>
  );
}
